import * as React from "react";
import { DataCard, IconBalanceRegular, skinVars, Stack, Text5 } from "@telefonica/mistica";
import type { TextProps } from "@chakra-ui/react";
import { Flex } from "@chakra-ui/react";
import { Text } from "@chakra-ui/react";

type NumericSpace = 0 | 2 | 4 | 8 | 12 | 16 | 24 | 32 | 40 | 48 | 56 | 64 | 72 | 80;
type FlexSpace = "around" | "between" | "evenly";

interface IProps {
	title: string;
	children?: React.ReactNode;
	stackSpace?: FlexSpace | NumericSpace;
	titleStyle?: TextProps;
}

export const DataInfo: React.FC<IProps> = (props) => {
	const { title, stackSpace, children, titleStyle } = props;

	return (
		<DataCard
			icon={
				<Flex
					h={"56px"}
					w={"56px"}
					backgroundColor={skinVars.colors.brandLow}
					borderRadius={"50% !important"}
					alignItems="center"
					justifyContent="center"
				>
					<IconBalanceRegular color={skinVars.colors.brand} />
				</Flex>
			}
			extra={
				typeof titleStyle === "undefined" ? (
					<Stack space={stackSpace ?? 16}>
						<Text5>{title}</Text5>
						{children}
					</Stack>
				) : (
					<Stack space={stackSpace ?? 16}>
						<Text {...titleStyle}>{title}</Text>
						{children}
					</Stack>
				)
			}
		/>
	);
};
